import ReactMarkdown from "react-markdown"
import type { Components } from "react-markdown"

const draftComponents: Components = {
  p: ({ children }) => <p className="mb-2 last:mb-0 text-gray-600">{children}</p>,
  strong: ({ children }) => <strong className="font-semibold text-gray-800">{children}</strong>,
  em: ({ children }) => <em className="italic text-gray-600">{children}</em>,
  ul: ({ children }) => <ul className="list-disc list-inside space-y-1 mb-2 text-gray-600">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal list-inside space-y-1 mb-2 text-gray-600">{children}</ol>,
  li: ({ children }) => <li className="text-gray-600">{children}</li>,
  br: () => <br />,
}

interface DraftMarkdownSnippetProps {
  children?: React.ReactNode;
  className?: string;
}

export function DraftMarkdownSnippet({ children, className = "" }: DraftMarkdownSnippetProps) {
  if (children == null || children === "") return null
  const md = typeof children === "string" ? children : String(children)
  return (
    <div className={className}>
      <ReactMarkdown
        allowedElements={["p", "strong", "em", "br", "ul", "ol", "li"]}
        unwrapDisallowed
        components={draftComponents}
        skipHtml
      >
        {md}
      </ReactMarkdown>
    </div>
  )
}
